import { ReducerUtil } from 'doctivity-shared/utils';

import {
  API_PROVIDER_REPORTS_TABLE,
  API_PROVIDER_REPORTS_LIST,
  API_PROVIDER_REPORTS_UPSERT,
} from 'store/actions/providerReportsActions';

export const providerReports = (state = {}, action = null) => {
  const result = ReducerUtil.simpleReduce(
    state,
    action,
    API_PROVIDER_REPORTS_TABLE,
    API_PROVIDER_REPORTS_LIST,
    API_PROVIDER_REPORTS_UPSERT,
  );
  if (result.actionConsumed) {
    return result.state;
  }
  return state;
};
